module.exports = __webpack_public_path__ + "static/media/calamarsaPedra.3ef8c8cb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avis/calamarsaPedra.svg
// module id = 822
// module chunks = 0